var _desc, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon Country/hungary") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Country/hungary",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hungary",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.923,166.957 C5.633,194.691 0,224.686 0,256 C0,287.314 5.633,317.311 15.923,345.043 L256,367.304 L496.077,345.043 C506.367,317.311 512,287.314 512,256 C512,224.686 506.367,194.691 496.077,166.957 L256,144.696 L15.923,166.957 Z",
    id: "Path",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,0 C145.93,0 52.094,69.472 15.924,166.957 L496.079,166.957 C459.906,69.472 366.072,0 256,0 Z",
    id: "Path",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,512 C366.072,512 459.906,442.528 496.078,345.043 L15.924,345.043 C52.094,442.528 145.93,512 256,512 Z",
    id: "Path",
    fill: "#6DA544"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHu);
export default __webpack_public_path__ + "static/media/HU.52a4a59ad8daa1fb32b1fe2a1479beeb.svg";
export { ForwardRef as ReactComponent };